import React, { useState } from "react";
import { SlidersHorizontal, X } from "lucide-react";

export function FilterBar({ sort, setSort, brands, selectedBrands, setSelectedBrands, priceMin, setPriceMin, priceMax, setPriceMax, inStock, setInStock, onReset }) {
  const [open, setOpen] = useState(false);
  const toggleBrand = (b) => setSelectedBrands((cur) => (cur.includes(b) ? cur.filter((x) => x !== b) : [...cur, b]));
  const activeCount = selectedBrands.length + (priceMin ? 1 : 0) + (priceMax ? 1 : 0) + (inStock ? 1 : 0);
  return (
    <div className="mb-6" data-testid="filter-bar">
      <div className="flex flex-wrap items-center gap-3">
        <button onClick={() => setOpen((o) => !o)} data-testid="filter-toggle" className="flex items-center gap-2 rounded-full border border-border bg-card px-4 py-2.5 text-sm font-semibold transition-colors hover:border-primary">
          <SlidersHorizontal className="h-4 w-4" /> Filtre
          {activeCount > 0 && <span className="rounded-full bg-primary px-2 py-0.5 text-[11px] font-black text-primary-foreground" data-testid="filter-active-count">{activeCount}</span>}
        </button>
        <select value={sort} onChange={(e) => setSort(e.target.value)} data-testid="shop-sort" className="rounded-full border border-border bg-card px-4 py-2.5 text-sm shadow-sm outline-none transition-colors focus:border-primary">
          <option value="created">Nyeste</option>
          <option value="price_asc">Pris: lav til høj</option>
          <option value="price_desc">Pris: høj til lav</option>
          <option value="name">Navn A-Å</option>
        </select>
        {activeCount > 0 && (
          <button onClick={onReset} data-testid="filter-reset" className="flex items-center gap-1 text-sm text-muted-foreground transition-colors hover:text-primary">
            <X className="h-4 w-4" /> Nulstil filtre
          </button>
        )}
      </div>
      {open && (
        <div className="mt-3 rounded-2xl border border-border bg-card p-4 lux-shadow" data-testid="filter-panel">
          {brands.length > 0 && (
            <div className="mb-4">
              <p className="mb-2 text-xs font-bold uppercase tracking-wide text-muted-foreground">Mærker</p>
              <div className="flex flex-wrap gap-2">
                {brands.map((b) => (
                  <button key={b} onClick={() => toggleBrand(b)} data-testid={`filter-brand-${b}`}
                    className={`rounded-full border px-3 py-1.5 text-sm transition-colors ${selectedBrands.includes(b) ? "border-primary bg-primary/10 font-bold text-primary" : "border-border hover:border-primary/40"}`}>
                    {b}
                  </button>
                ))}
              </div>
            </div>
          )}
          <div className="flex flex-wrap items-end gap-4">
            <div>
              <p className="mb-1 text-xs font-bold uppercase tracking-wide text-muted-foreground">Pris fra (kr.)</p>
              <input type="number" min="0" value={priceMin} onChange={(e) => setPriceMin(e.target.value)} placeholder="0" data-testid="filter-price-min" className="w-28 rounded-lg border border-border bg-background px-3 py-2 text-sm outline-none focus:border-primary" />
            </div>
            <div>
              <p className="mb-1 text-xs font-bold uppercase tracking-wide text-muted-foreground">Pris til (kr.)</p>
              <input type="number" min="0" value={priceMax} onChange={(e) => setPriceMax(e.target.value)} placeholder="∞" data-testid="filter-price-max" className="w-28 rounded-lg border border-border bg-background px-3 py-2 text-sm outline-none focus:border-primary" />
            </div>
            <label className="flex cursor-pointer items-center gap-2 pb-2 text-sm font-semibold" data-testid="filter-instock">
              <input type="checkbox" checked={inStock} onChange={(e) => setInStock(e.target.checked)} className="h-4 w-4 accent-[#EC1E79]" /> Kun på lager
            </label>
          </div>
        </div>
      )}
    </div>
  );
}
